import {
    Component,
    EventEmitter,
    Input,
    Output,
    ChangeDetectionStrategy,
} from '@angular/core';
import { DxButtonComponent } from 'devextreme-angular/ui/button';

@Component({
    selector: 'app-counterparty-card',
    templateUrl: './counterparty-card.component.html',
    styleUrls: ['./counterparty-card.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [DxButtonComponent],
})
export class CounterpartyCardComponent {
    @Input() ctpVm!: CounterpartyCardViewModel;

    @Output() selectButtonClickEvent =
        new EventEmitter<CounterpartyCardViewModel>();

    onSelectButtonClick() {
        this.selectButtonClickEvent.emit(this.ctpVm);
    }
}

export interface CounterpartyCardViewModel {
    id: string;
    companyName: string;
    taxId: string;
    branch: string;
    address: string;
}
